import { render, staticRenderFns } from "./ReleasesOtherIdsEditPanel.vue?vue&type=template&id=de3e64ce"
import script from "./ReleasesOtherIdsEditPanel.vue?vue&type=script&lang=js"
export * from "./ReleasesOtherIdsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./ReleasesOtherIdsEditPanel.vue?vue&type=style&index=0&id=de3e64ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports